import React from "react";
import { Field, Text } from "@fluentui/react-components";
import EditableStringList from "./EditableStringList";

/**
 * Editor for keywords: { en: [...], fr: [...] }
 */
export default function MultilingualKeywords({ label, value, onChange, languages = ["en", "fr"], disabled }) {
  const safe = value && typeof value === "object" ? value : {};

  const updateLang = (lang, list) => {
    onChange({ ...safe, [lang]: list });
  };

  return (
    <Field label={label} className="field-style">
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {languages.map((lang) => (
          <div key={lang}>
            <Text size={200} weight="semibold" style={{ marginBottom: 4, display: "block" }}>
              {lang.toUpperCase()}
            </Text>
            <EditableStringList
              label=""
              value={safe[lang] || []}
              onChange={(list) => updateLang(lang, list)}
              placeholder={`Keyword (${lang.toUpperCase()})...`}
              disabled={disabled}
            />
          </div>
        ))}
      </div>
    </Field>
  );
}
